export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مطلوب تأكيد"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يجب تأكيد التفويض بكلمة مرور مؤقتة"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يجب تأكيد التفويض بالكلمة السحرية"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يجب تأكيد التسجيل برمز من رسالة SMS"])}
}